/**
 * Query key utilities for organizations hooks
 * Keys match backend controller method names
 */
export const organizationsKeys = {
  findAll: () => ["organizations", "findAll"] as const,
  findOne: (uuid: string) => ["organizations", "findOne", uuid] as const,
} as const
